let globalSheets: CSSStyleSheet[] | null = null;

export function getGlobalStyleSheets(): CSSStyleSheet[] {
  if (globalSheets === null) {
    const result: CSSStyleSheet[] = [];
    for (const ss of Array.from(document.styleSheets)) {
      try {
        const cssSheet = ss as CSSStyleSheet;
        const rules = Array.from(cssSheet.cssRules ?? []);
        const css = rules.map((rule) => rule.cssText).join(" ");
        if (!css) continue;
        const sheet = new CSSStyleSheet();
        sheet.replaceSync(css);
        result.push(sheet);
      } catch {
        // Ignore SecurityError for cross-origin stylesheets
        continue;
      }
    }
    globalSheets = result;
  }

  return globalSheets;
}

export function addGlobalStylesToShadowRoot(shadowRoot: ShadowRoot): void {
  const current = shadowRoot.adoptedStyleSheets ?? [];
  const toAdd = getGlobalStyleSheets();
  const next = current.slice();
  for (const s of toAdd) {
    if (!next.includes(s)) next.push(s);
  }
  shadowRoot.adoptedStyleSheets = next;
}
